import req from './req'

// 获取订单列表
export function getOrderList (params) {
  return req.get('/orders/list', params)
}

// 获取商品订单列表
export function getGoodsOrderList (params) {
  return req.get('/orders/items/list', params)
}
